export default {
  checkResult (text: any, record: any, ListTableContext: any) {
    const enums = ListTableContext.tableConfig.Nav_Enums?.find((item: any) => item.EnumName === 'OperationalStateEnum')
    const enumsOptions = enums?.options ?? []
    const style = record.INSPECTION_RESULT === 1 ? { color: 'red' } : undefined
    const value = enumsOptions.find((item: any) => item.value === text)?.label
    return <span style={style}>{value || text}</span>
  },
}